import { getParams } from '../../utils';

//获取用户列表
export const boxUserRecord = (data = {}) => {
  const search = getParams(data);

  let url = `/ai-web/fromDr/boxUserRecord?` + search;

  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//新增用户
export const addBoxUser = (data = {}) => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/addBoxUser`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取用户类型列表
export const userTypes = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/userTypes`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//修改用户信息
export const modifyBoxUser = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/modifyBoxUser`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//删除用户
export const deleteBoxUser = userId => {
  const init = {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(`/ai-web/fromDr/deleteBoxUser?id=${userId}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取角色列表
export const roleInfoRecord = (data = {}) => {
  const search = getParams(data);
  const url = `/ai-web/fromDr/roleInfoRecord?${search}`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//获取所有菜单
export const getMenus = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/getMenus`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//新增角色
export const addRoleInfo = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/addRoleInfo`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//修改角色
export const modifyRoleInfo = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/modifyRoleInfo`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//删除角色
export const deleteRoleInfo = id => {
  const init = {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(`/ai-web/fromDr/deleteRoleInfo?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//新增机构
export const addinstitution = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/addinstitution`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取下级区域
export const getArea = pid => {
  const init = {
    method: 'GET',
  };
  return fetch(`/ai-web/fromDr/getArea?pid=${pid}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//修改机构信息
export const modifyinstitution = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/modifyinstitution`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//删除机构
export const deleteinstitution = id => {
  const init = {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(`/ai-web/fromDr/deleteinstitution?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取报告内容（合并后）
export const getTemplateReport4Study = (id, type, token) => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  let url = `/ai-web/fromDr/getTemplateReport4Study?studyDrId=${id}&aiProductType=${type}`;
  if (token) url += `&token=${token}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//获取操作日志列表
export const operationLog = data => {
  const search = getParams(data);
  let url = `/ai-web/operationLog/listByPage?` + decodeURI(decodeURI(search));
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//大盘数据
export const marketData = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/listByPage?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//
export const marketDataRate = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/listRateByPage?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

// 慧眼 - AI质控详情
export const statisticsAiQcList = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/ai/qcList?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

// 慧眼 - 病毒性肺炎详情
export const statisticsAiVpList = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/ai/vpList?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

// 慧眼 - 常见肺部疾病详情
export const statisticsAiLdList = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/ai/ldList?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

// 慧眼 - 肺结核详情
export const statisticsAiTuberList = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/ai/tuberList?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//  慧眼 - 医生审核详情
export const statisticsDoctorReviewList = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/doctor/reviewList?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//AI应用-其他
export const handleTimeList = data => {
  const search = getParams(data);
  const init = { method: 'GET' };
  return fetch(`/ai-web/statistics/other/handleTimeList?${search}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

// 慧眼 - 传片量总览
export const statisticsAiDicom = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/ai/dicom?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//查询dicom的自动报告
export const selectAiReport = id => {
  let url = `/ai-web/aiReport/selectAiReport?dicomId=${id}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//保存选中的报告内容
export const updateAdopted = data => {
  let url = `/ai-web/aiReport/updateAdopted`;
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//转诊反馈弹窗
export const feedbackModle = data => {
  let url = `/ai-web/tubeStudy/referralCallBack`;
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//转诊反馈列表
export const referralList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/tubeStudy/referralList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//任务提示
export const taskCountTip = () => {
  let url = `/ai-web/diagStatistics/alertCount`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//任务提示
export const ctTaskCountTip = () => {
  let url = `/ai-web-ct/diagStatistics/alertCount`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

export const getSnapshotByPage = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/instSnapshotByPage?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

export const instLoginByPage = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/instLoginByPage?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
export const synOnlineDetail = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/synOnlineDetail?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
export const marketDataOnlineDetail = data => {
  const search = getParams(data);
  let url = `/ai-web/statistics/marketData/onlineDetail?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
export const getSerialNumber = data => {
  let url = `/ai-web/boxuser/serialNumber`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//保存用户行为
export const saveEvent = data => {
  let url = `/ai-web/pageEvent/saveEvent`;
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//保存CT用户行为
export const ctSaveEvent = data => {
  let url = `/ai-web-ct/pageEvent/saveEvent`;
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//查询用户行为
export const pageEventList = data => {
  let url = `/ai-web/pageEvent/listByPage`;
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//用户行为搜索条件
export const pageEventSearch = () => {
  let url = `/ai-web/pageEvent/options`;
  const init = { method: 'GET' };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
